<script setup>
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus } from '@digitalpa/pro-solid-svg-icons'

library.add( faPlus )

const route = useRoute()
const router = useRouter()
const props = defineProps(['updatePageTitle'])

const title = ref('')
const canAdd = ref(false)
const routeAdd = ref('')

onMounted(() => {
  props.updatePageTitle(route.meta.title)
  canAdd.value = route.meta.permissions && route.meta.permissions.canAdd ? route.meta.permissions.canAdd : false
  routeAdd.value = route.name + '--new';
})

watch(
  () => route.meta,
  (meta) => {
    props.updatePageTitle(route.meta.title)
    canAdd.value = route.meta.permissions && route.meta.permissions.canAdd ? route.meta.permissions.canAdd : false
    routeAdd.value = route.name + '--new';
  }
)

</script>

<template>

  <div class="app-content-header">
    <div class="container-fluid">
      <div class="row mb-0 py-3">

        <div class="col-auto">
          <h1 class="m-0">
            <slot></slot>
          </h1>
        </div>

        <div class="col-auto" v-if="canAdd">

          <router-link v-if="canAdd && router.hasRoute(routeAdd)" :to="{name: routeAdd}">
            <button
              class="btn btn-primary btn-sm mx-2 h-100">
              <font-awesome-icon icon="fa-plus"></font-awesome-icon>
              Aggiungi
            </button>
          </router-link>

        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
